export const fadeAnimate = {
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};
export const transion = {
  duration: 0.5,
};
